module.exports = __webpack_public_path__ + "img/palme.d4312c35.jpg";